import { render, staticRenderFns } from "./BaseEventPicker.vue?vue&type=template&id=518cf74f&"
import script from "./BaseEventPicker.vue?vue&type=script&lang=js&"
export * from "./BaseEventPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports